export * as sp from "./sp.json";
export * as en from "./en.json";
